import React from 'react'

function banner({ keycloak, language }) {
    const toRegis = () => {
        let lang = language === 'cn' ? 'zh-cn' : language
        window.location.href = `${keycloak.createRegisterUrl()}&ui_locales=${lang}&clear=true`
    }

    return (
        <>
            {
                !keycloak.authenticated ? (
                    // eslint-disable-next-line 
                    <a
                        target="_blank"
                        onClick={toRegis}
                    >
                        <img
                            className="landing-banner banner-1"
                            alt="banner"
                            src={process.env.PUBLIC_URL + '/img/banner_1.png'}
                        />
                    </a>
                ) : null
            }
        </>
    )
}

export default banner
